export default __webpack_public_path__ + "static/890-947de4da6a4482b3304415b220deae44.gif";